import { Component, Output, EventEmitter, Input } from "@angular/core";
import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";


@Component({
    selector: 'new-password-form',
    styleUrls: ['./newPassword-form.component.scss'],
    templateUrl: './newPassword-form.component.html'
})
export class NewPasswordComponent {
    @Input() isChangePassword : boolean = false;
    @Output() onSubitPasswordClick = new EventEmitter<PasswordChangeData>();

    password: string;
    newPassword: string;
    newPasswordConfirmation: string;

    public clearFileds() {
        this.password = null;
        this.newPassword = null;
        this.newPasswordConfirmation = null;
    }

    changePassword(currentPassword : string, newPassword : string) {
        this.onSubitPasswordClick.emit(new PasswordChangeData(currentPassword, newPassword));
    }
    
    private get canChangePassword(): boolean {
        return this.newPassword && this.newPasswordConfirmation
          && this.newPassword.length > 0
          && this.newPassword == this.newPasswordConfirmation;
      }

    private readonly _newPasswordValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
        const password : string = control.value;
        if (!password) {
          return null;
        }
    
        const isLatinString = /^[a-zA-Z!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~\d]+$/.test(password);
        const hasLowercase = /[a-z]/.test(password);
        const hasUppercase = /[A-Z]/.test(password);
        const hasNumber = /\d/.test(password);
        const hasSpecial = /[!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/.test(password);
    
        const errors = {};
        if (!isLatinString) {
          errors['latin'] = true;
        }
        if (!hasLowercase) {
          errors['lowercase'] = true;
        }
        if (!hasUppercase) {
          errors['uppercase'] = true;
        }
        if (!hasNumber) {
          errors['number'] = true;
        }
        if (!hasSpecial) {
          errors['special'] = true;
        }
        if (password.length < 10) {
          errors['minlength'] = true;
        }
    
        return Object.keys(errors).length ? errors : null;
      };
    
      private readonly _newPasswordConfirmationValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
        if (this.newPassword == control.value)
          return null;
    
        return { "passwordsNotMatch": {} };
      };
}

export class PasswordChangeData {
    public readonly currentPassword : string;
    public readonly newPassword : string;

    constructor(currentPassword : string, newPassword : string) {
        this.currentPassword = currentPassword;
        this.newPassword = newPassword;
    }
}


// WEBPACK FOOTER //
// /app/SPA/src/app/account/asset/newPassword/newPassword-form.component.ts